import { z } from 'zod';

export const updateCategoryParamsSchema = z.object({
  category_id: z.uuid('Invalid category ID'),
});

export const updateCategorySchema = z.object({
  parent_id: z.uuid('Invalid parent ID').optional().nullable(),
  slug: z
    .string()
    .min(1, 'Slug is required')
    .max(120, 'Slug must be less than 120 characters')
    .regex(/^[a-zA-Z0-9-]+$/, 'Slug must contain only letters, numbers, and hyphens')
    .optional(),
  label: z.string().min(1, 'Label is required').max(255, 'Label must be less than 255 characters').optional(),
  is_active: z.boolean().optional(),
  metadata: z.record(z.string(), z.unknown()).optional(),
});

export type UpdateCategoryParamsPayload = z.infer<typeof updateCategoryParamsSchema>;
export type UpdateCategoryPayload = z.infer<typeof updateCategorySchema>;
